import { render, staticRenderFns } from "./PasswordComponent.vue?vue&type=template&id=0aae921d"
import script from "./PasswordComponent.vue?vue&type=script&lang=js"
export * from "./PasswordComponent.vue?vue&type=script&lang=js"
import style0 from "./PasswordComponent.vue?vue&type=style&index=0&id=0aae921d&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports